<app-left-menu-ui-left-menu
  [isOpen]="isOpen$ | async | defaultTo: false"
  [withConsole]="withConsole$ | async | defaultTo: false"
  [version]="version"
  (logout)="onLogout()"
  (open)="onOpen()"
></app-left-menu-ui-left-menu>
